import React, { Component } from 'react';
import './Footer.css';


class Footer extends Component {

  render() {
    return (
      <div>
        <section className="footer">
          <div className="container">
            <h3>CPAK, Inc.</h3>
            <ul className="list-inline">
              <li><a href="/about">About</a></li>
              <li><a href="/products">Products</a></li>
              {/*<li><a href="">Request a free quote</a></li>*/}
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>
        </section>
        <footer>
          <p className="text-center">All Rights Reserved.</p>
        </footer>
      </div>
    )
  }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Layout/Footer/Footer.js
 **/